import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed
  const [name, setName] = useState("");

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setName(data.boa_name || "");
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* keep polling */ }
      if (tries++ < 8) setTimeout(poll, 2000);
      else setState("failed");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="grain min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-success-page">
        {state === "checking" && (<><Loader2 className="w-12 h-12 text-qbprimary animate-spin mx-auto mb-6" />
          <h1 className="font-display text-3xl">Confirming your acquisition…</h1>
          <p className="text-qbfg/50 mt-3">Please hold while we verify payment.</p></>)}
        {state === "paid" && (<><CheckCircle2 className="w-14 h-14 text-qbprimary mx-auto mb-6" />
          <h1 className="font-display text-4xl">Congratulations</h1>
          <p className="text-qbfg/60 mt-4">{name ? `${name} is yours.` : "Your acquisition is confirmed."} We'll email you shipping arrangements and lineage paperwork shortly.</p>
          <Link to="/shop" className="inline-block mt-8 px-7 py-3.5 rounded-full bg-qbprimary text-qbbg hover:bg-qbfg transition-colors">Back to collection</Link></>)}
        {state === "failed" && (<><XCircle className="w-14 h-14 text-qbsecondary mx-auto mb-6" />
          <h1 className="font-display text-3xl">We couldn't confirm payment</h1>
          <p className="text-qbfg/50 mt-3">If you were charged, contact us and we'll sort it immediately.</p>
          <Link to="/shop" className="inline-block mt-8 px-7 py-3.5 rounded-full border border-white/25 hover:border-qbprimary transition-colors">Back to collection</Link></>)}
      </div>
    </div>
  );
}
